export default __webpack_public_path__ + "static/media/loading.b85fc5f2.png";